import cookie from './cookie';

const channelKeys = APP_CONFIG.channelKeys || '';

function isChannelKeyEffect(){
    const channelKey = cookie.getCookie('channel_key') || '';

    if( channelKey && channelKeys.indexOf(channelKey) >= 0) {
        return true;
    }

    return false;
}

function getChannelKey(){
    const channelKey = cookie.getCookie('channel_key');
    if( channelKey && channelKeys.indexOf(channelKey) >= 0) {
        return channelKey;
    }
    return '';
}

// 解析当前生效的 channelKey（不写 cookie），供 lang.js 解析语言列表用。
// 只看路径：带 /<channelKey> 前缀的入口用该入口自己的语言列表，其余路径一律用渠道默认列表。
function resolveChannelKey(){
    const pathKey = document.location.pathname.split('/')[1];
    if( pathKey && channelKeys && channelKeys.indexOf(pathKey) >= 0 ){
        return pathKey;
    }
    return '';
}

function setChannelKeyFromUrl(){
    const channelKey = document.location.pathname.split("/")[1];
    if( channelKey && channelKeys && channelKeys.indexOf(channelKey) >= 0 ){
      cookie.setCookie('channel_key', channelKey);
    } else {
      cookie.setCookie('channel_key', "");
    }

    return cookie.getCookie('channel_key');
}

module.exports = {
    isChannelKeyEffect,
    channelKeys,
    getChannelKey,
    resolveChannelKey,
    setChannelKeyFromUrl,
}


// WEBPACK FOOTER //
// ./src/common/channel.js